module.exports = __webpack_public_path__ + "static/media/shopifyCard.38ee7e7a.png";